import {map as _map} from 'lodash';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';

import HeaderRenderer from '@appComponents/HeaderRenderer';
import {FilterQueryWrapper, FilterUrlParamsWrapper} from '@appComponents/HOCFiltersQueryWrapper';
import {getSearchFilters} from '@utils/filters';
import {convertToInt} from '@utils/helpers';
import useQueryCustom from '@utils/hooks/useQueryCustom';
import mapModulesToProps from '@utils/mapModulesToProps';
import navigation from '@constants/navigation';
import {GetSpiideoCompetitorMappingsForTable} from '@graphql/spiideoCompetitorMapping/query';

import SpiideoCompetitorMappingsFilters, {
    DEFAULT_FILTER_VALUES,
    FILTER_KEY,
} from '../components/SpiideoCompetitorMappingsFilters';
import SpiideoCompetitorMappingsIndexButtons from '../components/SpiideoCompetitorMappingsIndexButtons';
import SpiideoCompetitorMappingsTable from '../components/SpiideoCompetitorMappingsTable';
import {exportExcel} from '../utils/export/spiideoCompetitorMappingsIndexExcel';

const SpiideoCompetitorsIndex = (props) => {
    const {filters, Menu} = props;

    useEffect(() => {
        Menu.storeMenu(navigation.infrastructure.key);
    }, []);

    const {
        data: {
            spiideoCompetitorMappings,
        } = {},
        loading,
    } = useQueryCustom({
        query: GetSpiideoCompetitorMappingsForTable,
        options: {
            variables: {
                search: filters.search || DEFAULT_FILTER_VALUES.search,
                sport: filters.sports
                    ? _map(filters.sports, (s) => convertToInt(s))
                    : DEFAULT_FILTER_VALUES.sports,
                tournament_category: filters.tournamentCategories
                    ? _map(filters.tournamentCategories, (c) => convertToInt(c))
                    : DEFAULT_FILTER_VALUES.tournamentCategories,
            },
            refetch: filters.lastClickSubmit,
        },
    });

    const data = spiideoCompetitorMappings ?? [];

    return (
        <div>
            <HeaderRenderer
                messagesBoxNames='spiideoCompetitorMapping'
                buttons={SpiideoCompetitorMappingsIndexButtons}
                exportExcelParams={exportExcel(data)}
                filters={SpiideoCompetitorMappingsFilters}
                filtersProps={{loading}}
                filtersButtonName={FILTER_KEY}
                loading={loading}
            />
            <div className='table-container'>
                <SpiideoCompetitorMappingsTable
                    loading={loading}
                    spiideoCompetitorMappings={data}
                />
            </div>
        </div>
    );
};

SpiideoCompetitorsIndex.propTypes = {
    filters: PropTypes.object.isRequired,
    Menu: PropTypes.object,
};

SpiideoCompetitorsIndex.displayName = 'SpiideoCompetitorsIndex';

const mapStateToProps = (state) => ({
    filters: getSearchFilters(state, FILTER_KEY, DEFAULT_FILTER_VALUES),
});

const SpiideoCompetitorsIndexWrapped = FilterQueryWrapper(SpiideoCompetitorsIndex, {
    queryForRefresh: 'GetSpiideoCompetitorMappingsForTable',
    filterUrls: ['spiideoMappings.competitors'],
});

export default withRouter(connect(
    mapStateToProps,
    mapModulesToProps(['Menu'])
)(FilterUrlParamsWrapper(SpiideoCompetitorsIndexWrapped, DEFAULT_FILTER_VALUES)));
